module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.values), function(opt, index) {
    return _c('div', {
      key: index,
      class: 'col-xs-' + opt.grid
    }, [(!['row'].includes(opt.type)) ? _c('div', {
      staticClass: "form-group"
    }, [(opt.type == 'divider') ? _c('hr') : _c('div', [(_vm.specialReportColumnTypeComponents[_vm.getFieldTypeFromFieldName(opt.name)]) ? _c('div', [_c('p', [_vm._v(_vm._s(opt.title) + ":")]), _vm._v(" "), _c(_vm.specialReportColumnTypeComponents[_vm.getFieldTypeFromFieldName(opt.name)], {
      tag: "component",
      attrs: {
        "data": {
          td: opt.value
        }
      }
    })], 1) : (opt.type == 'signature' || _vm.isSignatureDisplayType(index)) ? _c('div', [_c('p', [_vm._v(_vm._s(opt.title) + ":")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": opt.raw,
        "alt": ""
      }
    })]) : (_vm.isFileDisplayType(index)) ? _c('div', [_c('p', [_vm._v(_vm._s(opt.title) + ":")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getFileNameFromValue(opt.value)))])]) : _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(opt.title)
      }
    }, [_vm._v(": ")]), _vm._v(" "), (!['text-entry', 'signature'].includes(opt.type)) ? _c('strong', {
      domProps: {
        "innerHTML": _vm._s(opt.value)
      }
    }) : _vm._e()])])]) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a295490","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/VueFormView.vue
// module id = 1572
// module chunks = 1